var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-field"},[_c('label',[_vm._v("颜色")]),_c('div',{staticClass:"content"},[_c('el-color-picker',{attrs:{"show-alpha":"","value":_vm.style.color},on:{"active-change":_vm.setColor}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }